import type { R } from "../types";
import { axiosInstance } from "../../axios-instance";
import qs from "qs";
import { qsOptions } from "../qsOptions";
import type { AxiosRequestConfig } from "axios";
import type {
  IDeleteLoanOfficerRequest,
  IDeleteLoanOfficerResponse,
  IGetLoanOfficerProfileByUserIdRequest,
  IGetLoanOfficerProfileByUserIdResponse,
  IGetLoanOfficersRequest,
  IGetLoanOfficersResponse,
  IUpdateLoanOfficerRequest,
  IUpdateLoanOfficerResponse,
} from "./types";

export class LoanOfficersService {
  async getAll(
    p: IGetLoanOfficersRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLoanOfficersResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/loanOfficer/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteLoanOfficer(
    p: IDeleteLoanOfficerRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteLoanOfficerResponse> {
    try {
      return axiosInstance.delete(`/api/loanOfficer/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getProfileByUserId(
    p: IGetLoanOfficerProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLoanOfficerProfileByUserIdResponse> {
    try {
      return axiosInstance.get(`/api/loanOfficer/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateProfile(
    p: IUpdateLoanOfficerRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateLoanOfficerResponse> {
    try {
      return axiosInstance.put(`/api/loanOfficer/updateLoanOfficer`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
